module.exports = __webpack_public_path__ + "img/40380157.649d3039.png";